import { render, staticRenderFns } from "./PdlDetailInformation.vue?vue&type=template&id=4d5fea83&scoped=true"
import script from "./PdlDetailInformation.vue?vue&type=script&lang=js"
export * from "./PdlDetailInformation.vue?vue&type=script&lang=js"
import style0 from "./PdlDetailInformation.vue?vue&type=style&index=0&id=4d5fea83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5fea83",
  null
  
)

export default component.exports